/**
 * Created by craig on 10/13/13.
 */
define('absolute/multipagegenerator',['pixi', 'absolute/coords', 'lodash'],
	function (PIXI, Coords, _) {
		var MultiPageGenerator = function (settings) {

			var defaultSettings = {
				width: 0,
				height: 0,
				cardScale: 0.83,
				padding: {'x': Coords.x(50), 'y': Coords.y(50)},
				itemWidth: 0,
				itemHeight: 0
			};

			this.initMultiPageGenerator(_.extend(defaultSettings, settings));

		};

		MultiPageGenerator.prototype.initMultiPageGenerator = function (settings) {

			this.settings = settings;
			this.width = this.settings.width;
			this.height = this.settings.height;
			this.startY = settings.startY || 0;
		};

		MultiPageGenerator.prototype.getPages = function (items) {

			this.items = items;
			this.pages = [];

			this.cellWidth = (this.settings.itemWidth * this.settings.cardScale) + (this.settings.padding.x);

			this.colsPerPage = Math.floor((this.settings.maxWidth || this.width) / this.cellWidth);
			this.cardScale = this.settings.cardScale + (((this.settings.maxWidth || this.width) / this.cellWidth) % 1)
				/ this.colsPerPage;

			this.rowsPerPage = Math.ceil(this.items.length / this.colsPerPage);

			var totalRows = this.items.length / this.colsPerPage,
				totalPages = Math.ceil(totalRows / this.rowsPerPage);

			for (var i = 0; i < totalPages; i += 1) {

				var startIndex = (this.rowsPerPage * this.colsPerPage) * i,
					endIndex = (this.rowsPerPage * this.colsPerPage) * (i + 1);

				if (endIndex > this.items.length) {
					endIndex = this.items.length;
				}

				this.pages.push(this.makePage(this.items.slice(startIndex, endIndex), this.cardScale));

			}

			return this.pages;
		};

		MultiPageGenerator.prototype.makePage = function (items, cardScale) {
			var page = new PIXI.DisplayObjectContainer(),
				itemIndex = 0, item, row, col,
				totalRows = Math.ceil(this.items.length / this.colsPerPage);
			this.checkAndUpdateGraphicsSize(items);
			for (row = 0; row < this.rowsPerPage; row++) {
				for (col = 0; col < this.colsPerPage && itemIndex < items.length; col++) {
					var isAlignCenter = row === totalRows - 1 && this.colsPerPage > 1 && this.settings.align === 'center';
					item = items[itemIndex];
					item.x = (isAlignCenter) ?
						page.width / 2 +
						col * (item.width * cardScale / 2 + this.settings.padding.x) -
						(item.width * cardScale + this.settings.padding.x) * (this.colsPerPage - col - 1) / 2
						:
						col * (item.width * cardScale + this.settings.padding.x);
					item.y = row * (item.height * cardScale + this.settings.padding.y) + this.startY || 0;
					item.scale.x = item.scale.y = cardScale;
					page.addChild(item);
					itemIndex++;
				}
			}

			return page;

		};

		MultiPageGenerator.prototype.checkAndUpdateGraphicsSize = function (items) {
			if (!this.settings.keepOneLine) return;
			for (var i = 1; i < items.length; i++) {
				if (items[i] instanceof PIXI.Graphics) {
					items[i].width = items[0].width;
					items[i].height = items[0].height;
				}
			}
		};

		MultiPageGenerator.prototype.updateSettings = function (settings) {
			this.settings = settings;
		};

		return MultiPageGenerator;
	}
);


